// pages/ContactPage.jsx
// Page de contact : renvoie vers le formulaire du site vocaverb.com, dans la langue choisie dans l'app

import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'lucide-react';
import './ContactPage.css';

// Adresses publiques des pages Contact du site WordPress (vérifiées sur vocaverb.com le 09/10/2026)
const URL_CONTACT_SITE = {
  fr: 'https://vocaverb.com/fr/contact/',
  es: 'https://vocaverb.com/es/contacto/',
  en: 'https://vocaverb.com/en/contact-us/',
};

export default function ContactPage() {
  const { t, i18n } = useTranslation();
  const langue = (i18n.language || 'fr').slice(0, 2);
  const urlContact = URL_CONTACT_SITE[langue] || URL_CONTACT_SITE.fr;

  return (
    <div className="contact-page">
      <div className="contact-container">
        <header className="contact-header">
          <h1 className="contact-title">{t('contact.title')}</h1>
          <p className="contact-subtitle">{t('contact.subtitle')}</p>
        </header>

        <div className="contact-card">
          <p>{t('contact.intro')}</p>
          <a
            className="contact-link-button"
            href={urlContact}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('contact.bouton')}
            <ExternalLink size={18} />
          </a>
        </div>
      </div>
    </div>
  );
}
